<template>
  <SecondaryModal
    name="delete-messages"
    :title="$t('chat.deleteMessages.title')"
    @before-open="reset"
    v-if="chat"
  >
    <div v-html="$t('chat.deleteMessages.confirmation', { n: pickedCount })"></div>

    <div v-if="isGroup" :class="$style.checkWrap">
      <BaseSwitch v-if="isAdmin || isAllMyMessages" v-model="isDeleteForAll">{{ $t('chat.deleteMessages.forAll') }}</BaseSwitch>
    </div>

    <div v-if="isPrivate" :class="$style.checkWrap">
      <BaseSwitch v-model="isDeleteForAll">{{ $t('chat.deleteMessages.forMeAndReceiver', { name: receiverName }) }}</BaseSwitch>
    </div>

    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide('delete-messages')">{{ $t('buttonCancel') }}</BaseButton>
      <BaseButton
        oval
        :loading="loading"
        :disabled="isDisabled"
        @click="deleteRequest"
      >{{ $t('buttonDelete') }}</BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from './SecondaryModal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'delete-messages-popup',
  components: {
    SecondaryModal
  },
  props: {
    messageIds: {
      type: Array,
      default: () => ([])
    },
    onDeleted: {
      type: Function,
      default: () => function () {}
    },
    beforeDelete: {
      type: Function,
      default: () => function () {}
    }
  },
  data () {
    return {
      loading: false,
      isDeleteForAll: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      messageById: 'entities/messages/getById',
      chatById: 'entities/chats/getById'
    }),
    pickedCount () {
      return this.messageIds.length
    },
    messages () {
      return this.messageIds.map(id => this.messageById(id))
    },
    chat () {
      if (!this.pickedCount) return
      return this.chatById(this.messages[0].chatId)
    },
    isPrivate () {
      if (!this.chat) return
      return this.chat.typeName === 'one-to-one'
    },
    isGroup () {
      if (!this.chat) return
      return this.chat.typeName === 'group'
    },
    receiverName () {
      if (!this.isPrivate) return
      const receiver = this.chat.participantsUsers.find(user => user.userId !== this.user.id)
      return receiver.displayName
    },
    isAdmin () {
      if (!this.chat) return
      // return this.chat.admins.find(admUser => admUser.username === this.user.id)
      return true
    },
    myMessages () {
      return this.messages.filter(message => message.senderId === this.user.id)
    },
    isAllMyMessages () {
      return this.messages.every(message => message.senderId === this.user.id)
    },
    // isAllowDeleteForEveryone () {
    //   if (this.isAdmin) return true
    //   return this.messages.every(message => message.senderId === this.user.id)
    // },
    isShowGroupSwitch () {
      return this.isGroup && this.isAllowDeleteForEveryone
    },
    isDisabled () {
      return !this.messageIds || !this.messageIds.length
    }
  },
  methods: {
    ...mapActions({
      deleteMessages: 'entities/messages/remove'
    }),
    reset () {
      this.loading = false
      this.isDeleteForAll = false
    },
    async deleteRequest () {
      if (this.isDisabled) return
      this.loading = true
      this.beforeDelete()
      const { messageIds, isDeleteForAll } = this
      await this.deleteMessages({
        chatId: this.chat.id,
        messageIds,
        isDeleteForAll
      })
      this.loading = false
      this.$modal.hide('delete-messages')
      this.onDeleted()
    }
  }
}
</script>

<style module lang="scss">
.checkWrap {
  margin-top: 8px;
  display: inline-block;
}
</style>
